export function NoPrint({ children }) {
	return <div className="no-print">{children}</div>
}
